import React from 'react';
import { Table } from 'antd';
import styles from '../../pages/admin/vendor/ManageVendors/ManageVendors.module.css';
import '../../App.css';

export const DataTable = ({ columns, data, dataLoading, actionLoading }) => {
  return (
    <Table
      className={styles['data-table']}
      columns={columns}
      bordered
      size="small"
      dataSource={data}
      pagination={{ position: ['bottomLeft'], pageSize: 8 }}
      loading={dataLoading || actionLoading}
    />
  );
};
